import { getRecommendations } from './Recommendation.js'

export const getCart = (callback = null, open = true) => {
  fetch('/cart?view=ajax', { method: 'GET' })
    .then((response) => response.json())
    .then((cart) => {
      window.updateCartCount(cart.cart.item_count)
      if (open) {
        getInlineCart((responseText) => {
          window.initInlineCart(responseText)
        })
      }
      if (callback) callback(cart)
    })
    .catch((e) => {
      console.error(e)
    })
}
window.getCart = getCart

export const addLineItems = (callback = null, lineItems = [], open = true, reload = false) => {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ items: lineItems }),
  })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (reload) location.reload()
      else {
        getCart((cart) => {
          window.updateFreeShippingBar(cart)
          updatePdpQtyLimitMsg(null, cart)
        }, false)
        if (open) {
          getInlineCart((responseText) => {
            window.initInlineCart(responseText)
          })
        }
        if (callback) callback(data)
      }
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}
window.addLineItems = addLineItems

export const updateCart = (callback = null, updates = {}, open = true, reload = false) => {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (reload) location.reload()
      else {
        getCart((cart) => {
          window.updateFreeShippingBar(cart)
          updatePdpQtyLimitMsg(null, cart)
          if (callback) callback(cart.cart)
        }, false)
        if (open) {
          getInlineCart((responseText) => {
            window.initInlineCart(responseText)
          })
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}
window.updateCart = updateCart

export const getCartUpsells = (callback = null) => {
  getCart((cartData) => {
    console.log(cartData)
    const cart = cartData.cart
    const recommendData = cartData.recommendations
    const curVariantIds = cartData.cart.items.map((item) => item.variant_id)
    const desiredCount = 4
    let newUpsells = []
    if (cart.items.length > 0) {
      const perCount = Math.ceil(desiredCount / Math.min(cart.items.length, desiredCount))
      cart.items.forEach((item, index) => {
        if (index < desiredCount) {
          if (recommendData[item.variant_id] && recommendData[item.variant_id].length > 0) {
            const variants = recommendData[item.variant_id].map((data) => data.variant)
            let count = 0
            variants.forEach((variant) => {
              if (
                !curVariantIds.includes(variant.id) &&
                count < perCount &&
                variant.available &&
                !variant.name.includes('Build Your Own Proxy') &&
                !newUpsells.filter((p) => p.variant.id == variant.id).length
              ) {
                newUpsells = newUpsells.concat([
                  {
                    variant: variant,
                    product: recommendData[item.variant_id].filter((data) => data.variant.id == variant.id)[0].product,
                  },
                ])
                count += 1
              }
            })
          } else {
            getRecommendations(
              (products) => {
                let count = 0
                products.forEach((product) => {
                  if (count < perCount && product.available && !product.title.includes('Build Your Own Proxy')) {
                    const firstAvailableVariant = product.variants.filter((variant) => variant.available)[0]
                    if (
                      !curVariantIds.includes(firstAvailableVariant.id) &&
                      !newUpsells.filter((p) => p.variant.id == firstAvailableVariant.id).length
                    ) {
                      newUpsells = newUpsells.concat([
                        {
                          variant: firstAvailableVariant,
                          product: product,
                        },
                      ])
                      count += 1
                    }
                  }
                })
              },
              item.product_id,
              8,
            )
          }
        }
      })
      setTimeout(() => {
        if (callback) callback(newUpsells)
      }, 2000)
    }
  }, false)
}
export const getInlineCart = (callback = null) => {
  fetch('/cart?view=inline', { method: 'GET' })
    .then((response) => response.text())
    .then((responseText) => {
      if (callback) callback(responseText)
    })
    .catch((e) => {
      console.error(e)
    })
}

export const updatePdpQtyLimitMsg = (callback = null, cart) => {
  const pdpForm = document.querySelector('product-form')
  if (location.href.includes('/products') && pdpForm) {
    const currentVariantId = parseInt(pdpForm.querySelector('[name="id"]').value)
    const variantItem = cart.cart.items.filter((item) => item.variant_id == currentVariantId)[0]
    const limit = variantItem ? cart.limits[currentVariantId] : null
    if (variantItem && limit && limit <= variantItem.quantity) {
      const submitButton = pdpForm.querySelector('.product-form__buttons button[type="submit"]')
      const messageContainer = document.createElement('div')
      messageContainer.className = 'mt-2 text-black text-[11px] leading-3 flex items-center limit-message'
      messageContainer.innerHTML = `
        <span class='inline-block mr-2'>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9.33333C6.18889 9.33333 6.34722 9.26945 6.475 9.14167C6.60278 9.01389 6.66667 8.85556 6.66667 8.66667C6.66667 8.47778 6.60278 8.31944 6.475 8.19167C6.34722 8.06389 6.18889 8 6 8C5.81111 8 5.65278 8.06389 5.525 8.19167C5.39722 8.31944 5.33333 8.47778 5.33333 8.66667C5.33333 8.85556 5.39722 9.01389 5.525 9.14167C5.65278 9.26945 5.81111 9.33333 6 9.33333ZM5.33333 6.66667H6.66667V2.66667H5.33333V6.66667ZM3.5 12L0 8.5V3.5L3.5 0H8.5L12 3.5V8.5L8.5 12H3.5ZM4.06667 10.6667H7.93333L10.6667 7.93333V4.06667L7.93333 1.33333H4.06667L1.33333 4.06667V7.93333L4.06667 10.6667Z" fill="#E35B5B"/>
          </svg>
        </span>
        You've reached the max limit of ${limit}
      `
      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled')
        submitButton.parentElement.appendChild(messageContainer)
      }
    } else {
      const submitButton = pdpForm.querySelector('.product-form__buttons button[type="submit"]')
      if (submitButton) submitButton.removeAttribute('disabled')
      if (document.querySelector('.limit-message')) document.querySelector('.limit-message').remove()
    }
  }
}

// export const adjustBago = (callback = null, cart) => {
//   if (typeof window.gwpData != 'undefined' && window.gwpData && window.gwpData.threshold > 0) {
//     let totalPrice = 0
//     const threshold = window.gwpData.threshold * 100
//     let bagoInclude = false
//     let bagoQty = 0
//     cart.items.forEach((item) => {
//       if (item.variant_id != window.gwpData.variantId) totalPrice += item.final_line_price
//       else {
//         bagoInclude = true
//         bagoQty = item.quantity
//       }
//     })
//     const updates = {}
//     if (totalPrice >= threshold && bagoInclude) {
//       if (bagoQty > 1) updates[window.gwpData.variantId] = 1
//     } else {
//       updates[window.gwpData.variantId] = 0
//     }

//     if (typeof updates[window.gwpData.variantId] != 'undefined') {
//       fetch('/cart/update.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ updates }),
//       })
//         .then((response) => {
//           return response.json()
//         })
//         .then((data) => {
//           if (callback) callback(data)
//         })
//         .catch((error) => {
//           console.error('Error:', error)
//         })
//     } else {
//       if (callback) callback(null)
//     }
//   } else {
//     if (callback) callback(null)
//   }
// }
